import { useEffect, useState } from "react";
import { splitRemaining } from "../utils";

/**
 * 倒计时芯片：每秒刷新一次，显示「还剩 X天 X小时 X分 X秒」。
 *
 * - 剩余 < 7 天 → 琥珀色
 * - 剩余 < 1 天 → 红色（接近过期，但还没过期，仍能用）
 * - 已过期        → 红色 + 「已过期」
 * - 无 `notAfter` → 灰色 + 「无期限」
 */
export function LiveCountdown({
  notAfter,
  className = "",
}: {
  notAfter?: number;
  className?: string;
}) {
  const [now, setNow] = useState(() => Math.floor(Date.now() / 1000));

  useEffect(() => {
    if (!notAfter) return;
    const t = setInterval(() => setNow(Math.floor(Date.now() / 1000)), 1000);
    return () => clearInterval(t);
  }, [notAfter]);

  if (!notAfter) {
    return <span className={`chip ${className}`}>无期限</span>;
  }

  const totalSec = notAfter - now;
  if (totalSec <= 0) {
    return (
      <span className={`chip bg-red-50 text-red-700 ${className}`} title="已过期">
        已过期
      </span>
    );
  }

  const { days, hours, minutes, seconds } = splitRemaining(totalSec);

  let tone = "bg-emerald-50 text-emerald-700";
  if (totalSec < 86400) {
    tone = "bg-red-50 text-red-700";
  } else if (totalSec < 7 * 86400) {
    tone = "bg-amber-50 text-amber-800";
  }

  return (
    <span
      className={`chip ${tone} ${className}`}
      title={`截止 ${new Date(notAfter * 1000).toLocaleString()}`}
    >
      还剩 {days}天 {hours}小时 {minutes}分 {seconds}秒
    </span>
  );
}
